import React from 'react'
import {Moment} from 'moment'
import {DateFilterForm} from '@modifi/ui'

import Filter, {CommonFilterProps} from '../../ui/filter'
import {formatMomentToString, oneYearAgo, today} from '../../utils/formatMomentToString'

type DateFilterProps = CommonFilterProps & {
  filterKey?: string
  resetFrom?: Moment
  resetTo?: Moment
  preferFutureDates?: boolean
  numberOfMonths?: number
}

const DateFilter: React.FC<DateFilterProps> = ({
  filterKey = 'filter.createdOn',
  resetFrom = oneYearAgo,
  resetTo = today,
  ...restFilterProps
}) => {
  const getDefaultParams = (search: Record<string, any>) => ({
    defaultFrom: search[`${filterKey}.from`],
    defaultTo: search[`${filterKey}.to`],
  })

  const getSearchParams = ({from, to}: {from?: Moment; to?: Moment}) => ({
    [`${filterKey}.from`]: formatMomentToString(from),
    [`${filterKey}.to`]: formatMomentToString(to),
  })

  const getResetParams = () => ({
    defaultFrom: formatMomentToString(resetFrom),
    defaultTo: formatMomentToString(resetTo),
  })

  return (
    <Filter
      filterComponent={DateFilterForm}
      getDefaultParams={getDefaultParams}
      getSearchParams={getSearchParams}
      getResetParams={getResetParams}
      {...restFilterProps}
    />
  )
}

export default DateFilter
